export default "__VITE_ASSET__BLNAqEXl__"